//@flow

import parse from "html-react-parser";
import DOMPurify from "dompurify";

export const read = (text: string) => {
  if (text) {
    return parse(DOMPurify.sanitize(text));
  } else {
    console.error("The current key is not available in your translation file.");
    return "";
  }
};

export const readAndReplace = (text: string, replaceObject: Object) => {
  if (text) {
    return parse(DOMPurify.sanitize(text), replaceObject);
  } else {
    console.error("The current key is not available in your translation file.");
    return "";
  }
};

export const scrollToFormTop = (offset: number = 0) => {
  const mainLayout = document.getElementById("mainLayout");
  const shortFormContainer = document.getElementById("shortFormContainer");
  // $FlowFixMe
  const distance = shortFormContainer.getBoundingClientRect().top + mainLayout.scrollTop - offset;

  if (mainLayout) {
    try {
      mainLayout.scroll({ left: 0, top: distance, behavior: "smooth" });
    } catch (err) {
      mainLayout.scrollTop = distance;
      mainLayout.scrollLeft = 0;
    }
  }
};
